import Constants from "@usas/ui-web/utils/Constants";

export const localValidate = (formState) => {
  const errors = {};

  if (formState.omeMeetEntryId === Constants.DEFAULT_ID) {
    errors.omeMeetEntryId = 'Selection is required';
  }

  if (formState.orgUnitId === '') {
    errors.orgUnitId = 'Selection is required';
  }

  return errors;
};

const TeamEntrySelectOrgUnitValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
}

export default TeamEntrySelectOrgUnitValidation;